const setLocalShowPrintKOTButton = (val) => {
  localStorage.setItem("showPrintKOTButton", val);
};
export default setLocalShowPrintKOTButton;
